import './index.css'
import cn from 'clsx'
import * as React from 'react'
import InlineSVG from 'svg-inline-react'
import Icon from 'components/ui/icon'
import Column from '../column'
type Props = {
  readOnly?: boolean
  children: React.ReactElement<typeof Column>[]
  backgroundColor?: string
  color?: string
  disableEditing?: boolean
  disableDelete?: boolean
  disableCopy?: boolean
  editMode?: boolean
  index: number
  onEdit?: (index: number) => any
  onDuplicate?: (index: number) => any
  onDelete?: (index: number) => any
  draggable: boolean
  connectDragPreview?: (...args: Array<any>) => any
  connectDragSource?: (...args: Array<any>) => any
}

const Section = ({
  readOnly,
  children,
  backgroundColor,
  color,
  index,
  editMode,
  disableEditing,
  disableCopy,
  disableDelete,
  onEdit,
  onDuplicate,
  onDelete,
  draggable,
  connectDragSource,
  connectDragPreview,
}: Props): any | React.ReactElement<'div'> => {
  const displayOverlay =
    !readOnly && (!disableEditing || disableCopy || disableDelete)
  const content = (
    <div
      className={cn('content-editor__formatting-block', {
        'content-editor__formatting-block--readonly': readOnly,
        'content-editor__formatting-block--first': index === 0,
      })}
      style={{
        backgroundColor,
        color,
      }}
    >
      {displayOverlay && (
        <div className="content-editor__formatting-block__control-overlay">
          {draggable &&
            connectDragSource &&
            connectDragSource(
              <a
                className="content-editor__formatting-block__control-overlay__drag"
                title="Click and drag to move this block"
              >
                <Icon type="drag" width="1.4em" height="1.4em" />
              </a>,
            )}
          {!disableEditing && (
            <a
              className="content-editor__formatting-block__control-overlay__edit"
              onClick={onEdit ? () => onEdit(index) : undefined}
              title="Edit"
            >
              <Icon type="pen" width="1.4em" height="1.4em" />
            </a>
          )}
          {!disableCopy && (
            <a
              className="content-editor__formatting-block__control-overlay__duplicate"
              onClick={onDuplicate ? () => onDuplicate(index) : undefined}
              title="Duplicate"
            >
              <InlineSVG
                src={require('!svg-inline!assets/campaign-editor/icons/duplicate-icon.svg')}
              />
            </a>
          )}
          {!disableDelete && (
            <a
              className="content-editor__formatting-block__control-overlay__delete"
              onClick={onDelete ? () => onDelete(index) : undefined}
              title="Delete"
            >
              <Icon type="trash" width="1.4em" height="1.4em" />
            </a>
          )}
        </div>
      )}
      {children}
    </div>
  )
  return draggable && connectDragPreview ? connectDragPreview(content) : content
}

export default Section
